import React from 'react'
import MusicianPortfolioPopup from './musicianPortfolioPopup'
import getYouTubeID from 'get-youtube-id'
import { useAtom } from 'jotai'
import { myUserAtom } from '../../../State/Musician/myUserAtom'
import { Empty } from 'antd'

const MusicianPortfolio = ({ editMode }: { editMode: boolean }) => {
  const [myUser] = useAtom(myUserAtom)
  const [popupOpen, setPopupOpen] = React.useState(false)

  return (
    <>
      <div
        className={`lg:pb-0 pb-[4vh] flex flex-col w-full px-[15px] rounded-lg overflow-y-auto max-h-[340px] max-[1020px]:min-h-[370px] bg-gradient-to-b from-[#494949] to-[#242424] lg:mb-0 mb-10 items-center cursor-pointer mx-4 lg:mx-0`}
        onClick={() => setPopupOpen(true)}
      >
        <p className="text-lg lg:text-xl py-[5px]">Portfolio</p>
        {myUser.portfolioLinks.length > 0 &&
        myUser.portfolioLinks.filter((link) => link.provider === 'you_tube').length > 0 ? (
          <div className="grid grid-cols-2 gap-4 mt-2">
            {myUser.portfolioLinks
              .filter((link) => link.provider === 'you_tube')
              .map((video, index) =>
                index < 4 ? (
                  <img key={video.id} src={`https://img.youtube.com/vi/${getYouTubeID(video.url)}/default.jpg`} />
                ) : null,
              )}
          </div>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <span className="text-white">
                {editMode ? 'Click to add media to your portfolio' : 'No portfolio items available'}
              </span>
            }
          />
        )}
      </div>
      <MusicianPortfolioPopup popupOpen={popupOpen} setPopupOpen={setPopupOpen} editMode={editMode} />
    </>
  )
}

export default MusicianPortfolio
